// ----------------------------------------------------------------------

export default function Table(theme) {
    return {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: false,
            },
            root: {},
        },
    };
}
